// extracted by mini-css-extract-plugin
export default {"input":"Input-module__input___A0VWJ","variant-error":"Input-module__variant-error___PhgCv","variantError":"Input-module__variant-error___PhgCv"};